// extracted by mini-css-extract-plugin
export default {"region":"TcH3s","name":"Xs1pz"};